module.exports = __webpack_public_path__ + "static/media/status-send.165a9ea7.svg";